import { addCache } from 'api/caching'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { Integration, SellerCentralIntegration } from 'types'

import { CerebroPaginatedResponse } from '../types'

export const getOrganizationIntegrations = (
    organizationId: string,
    params: Record<string, unknown>
): Promise<CerebroPaginatedResponse<Integration>> =>
    orgScopedApiClient.get(
        `/api/organization/${organizationId}/integrations/`,
        { params }
    )
addCache(getOrganizationIntegrations)

export const getSellerCentralIntegrations = (
    params: Record<string, unknown>
): Promise<CerebroPaginatedResponse<SellerCentralIntegration>> =>
    orgScopedApiClient.get('/api/seller_central_account_integrations/', {
        params,
    })
addCache(getSellerCentralIntegrations)
